import React from "react";
import styled from "styled-components";
import { ClipLoader } from "react-spinners";
import Header from "../common/Header";
import { PrimaryButton } from "../common/Button";
import { withEditTopNine } from "../../core/withEditTopNine";
import Grid from "./Grid";
import Posts from "./Posts";

const EditTopNine = ({ newGridPosts, selectedGridBlockIndex, updateSelectedGridBlock, loading, ...props }) => (
  <React.Fragment>
    <TopNineHeader />
    <Container>
      <Grid
        items={newGridPosts}
        selectedIndex={selectedGridBlockIndex}
        updateSelectedGridBlock={updateSelectedGridBlock}
      />
      <Posts
        selectPost={props.updateGridBlock}
        selectedPostId={props.selectedPost.id}
      />
    </Container>
    <ButtonContainer>
      <ContinueButton
        disabled={loading}
        onClick={props.onClickContinue}
        loading={loading}
      >
        {"Continue"}
      </ContinueButton>
    </ButtonContainer>
  </React.Fragment>
);

const TopNineHeader = styled(Header)``;

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px;
`;

const ButtonContainer = styled.div`
  z-index: 3;
  background-color: #f8f8f8;
  border-top: 1px solid #e7e7e7;
  text-align: center;
  padding: 20px;
  position: fixed;
  left: 0;
  bottom: 0;
  height: 80px;
  width: 100%;
`;

const ContinueButton = styled(PrimaryButton)`
  margin: auto;
  min-height: 46px;
  max-width: 360px;
`;

const SpinnerContainer = styled.div`
  margin-right: 10px;
`;
export default withEditTopNine(EditTopNine);
